import { Component,  OnInit, Input  } from '@angular/core';
import { LogoService } from '../data/logo.service';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.css']
})
export class TableComponent implements OnInit {

@Input() prodId: any;

  data: any;
  logo :any;
  device : string;

  constructor(private logos: LogoService ) { }

  ngOnInit(): void {
    this.getData();

    this.logo = this.data[this.prodId];
  }

  getData(): void {
    this.logos.getLogoData().subscribe( data => this.data = data );
  }

  public findItemInArray(list: any,item: string): any {
	return list.find(x => x.viewport == item).imageUrl;
  }




}
